/**
 * @module modules/common/keyboard-shortcuts
 * @description Shared keyboard shortcut logic for Skia Perf.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    SHORTCUTS: function() {
        return SHORTCUTS;
    },
    ShortcutRegistry: function() {
        return ShortcutRegistry;
    },
    handleKeyboardShortcut: function() {
        return handleKeyboardShortcut;
    }
});
const SHORTCUTS = [
    {
        key: 'p',
        method: 'onTriagePositive',
        description: 'Mark as positive.',
        category: 'Triage'
    },
    {
        key: 'n',
        method: 'onTriageNegative',
        description: 'Mark as negative.',
        category: 'Triage'
    },
    {
        key: 'e',
        method: 'onTriageExisting',
        description: 'Mark as existing.',
        category: 'Triage'
    },
    {
        key: 'w',
        method: 'onZoomIn',
        description: 'Zoom in.',
        category: 'Navigation'
    },
    {
        key: ',',
        method: 'onZoomIn',
        description: 'Zoom in.',
        category: 'Navigation'
    },
    {
        key: 's',
        method: 'onZoomOut',
        description: 'Zoom out.',
        category: 'Navigation'
    },
    {
        key: 'o',
        method: 'onZoomOut',
        description: 'Zoom out.',
        category: 'Navigation'
    },
    {
        key: 'a',
        method: 'onPanLeft',
        description: 'Pan left.',
        category: 'Navigation'
    },
    {
        key: 'd',
        method: 'onPanRight',
        description: 'Pan right.',
        category: 'Navigation'
    },
    {
        key: 'g',
        method: 'onOpenReport',
        description: 'Open report.',
        category: 'Report'
    },
    {
        key: 'G',
        method: 'onOpenGroupReport',
        description: 'Open group report.',
        category: 'Report'
    },
    {
        key: '?',
        method: 'onOpenHelp',
        description: 'Show help.',
        category: 'General'
    }
];
let ShortcutRegistry = class ShortcutRegistry {
    static getInstance() {
        if (!ShortcutRegistry.instance) {
            ShortcutRegistry.instance = new ShortcutRegistry();
        }
        return ShortcutRegistry.instance;
    }
    populateFromShortcuts() {
        SHORTCUTS.forEach((s)=>{
            const category = s.category;
            if (!this.shortcuts.has(category)) {
                this.shortcuts.set(category, []);
            }
            this.shortcuts.get(category).push({
                key: s.key,
                action: s.description,
                description: s.description,
                method: s.method
            });
        });
    }
    register(category, shortcuts) {
        this.shortcuts.set(category, shortcuts);
    }
    getShortcuts() {
        return this.shortcuts;
    }
    reset() {
        this.shortcuts.clear();
        this.populateFromShortcuts();
    }
    constructor(){
        this.shortcuts = new Map();
        this.populateFromShortcuts();
    }
};
function handleKeyboardShortcut(e, handler) {
    // Ignore if typing in input or textarea
    if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) {
        return;
    }
    const shortcut = SHORTCUTS.find((s)=>s.key === e.key);
    if (shortcut && typeof handler[shortcut.method] === 'function') {
        handler[shortcut.method]();
    }
}
